import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/route/search', { params: request })
  },
  loadRoles: function() {
    return axios.get('/api/admin/roles/search', { params: {pageNumber: 1, pageSize: -1} });
  },
  loadOrganizations: function() {
    return axios.get('/api/organizations/search', { params: {pageNumber: 1, pageSize: -1, getRoles: true} });
  },
  find: function (id) {
    return axios.get('/api/route/find?id='+id);
  },
  save: function (data) {
    return axios.post('/api/route/save', data);
  },
  loadOrganizationList: function(search, serviceTypeId, includeRoles) {
    return axios.get('/api/organizations/getlist', {
      params: {
        search: search,
        serviceTypeId: serviceTypeId,
        includeRoles: includeRoles
      }
    });
  }
}